export let json = {
  "@context": "https://schema.org/",
  "@type": "Movie",
  "url": "https://example.com/2019-best-picture-noms#a-star-is-born",
  "director": { "@type": "Person", "name": "Bob Ross" },
  "name": "A Star Is Born",
  "image": "https://example.com/photos/6x9/photo.jpg",
  "dateCreated": "2018-10-05"
}